import * as React from "react";

function Dashboard() {
  return <div>
    Dashboard
  </div>;
}

export default React.memo(Dashboard);
